export function getApiErrorMapper(i18n: any): Function {
  return (function apiErrorMapper(error: any): string {
    switch (error?.Error) {
      case 'CampaignServiceInvalidDailyBudget': {
        return i18n.getString(_TL_('Invalid daily budget'));
      }
      case 'UnsupportedBiddingScheme': {
        return i18n.getString(_TL_('Unsupported bidding scheme'));
      }
      case 'InvalidTargetRoasValue': {
        return i18n.getString(_TL_('Invalid target ROAS value'));
      }
      default: {
        return i18n.getString(_TL_('An error occurred, please try again later'));
      }
    }
  });
}
